<ng-container *ngIf="entity">
    <div class="modal-header">
        <h5 class="modal-title">Move “{{entity.displayName}}”</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
    </div>
    <dirty-tracking [forms]="[moveForm]"></dirty-tracking>
    <form #moveForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
        <div class="modal-body">
            <label class="text-strong mb-1">Current Assignment:</label>
            <nav aria-label="breadcrumb" class="mb-3" *ngIf="entity.hierarchy.length > 0">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item" *ngFor="let parent of entity.hierarchy"><i
                            class="far fa-folder text-primary"></i> {{parent.text}}</li>
                </ol>
            </nav>
            <p class="text-italic" *ngIf="entity.hierarchy.length == 0">Top Level Account</p>
            <label class="text-strong mb-1">New Assignment:</label>
            <p class="text-italic" *ngIf="moveDetail.hierarchy.length == 0">Top Level Account</p>
            <nav aria-label="breadcrumb" class="mb-3" *ngIf="moveDetail.hierarchy.length != 0">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item" *ngFor="let parent of moveDetail.hierarchy"><i
                            class="far fa-folder text-primary"></i> {{parent.text}}</li>
                </ol>
            </nav>
            <div class="row gx-2 mb-4">
                <div class="col-md mb-3 mb-md-0 mobiscroll-select">
                    <label class="form-label d-block">Top Level Account</label>
                    <input id="move-account-input" class="mobi-input form-control form-control-lg"
                        placeholder="Select Account" mbsc-select [data]="accounts" [(ngModel)]="accountId"
                        name="accountId" [mbscOptions]="accountOptions" />
                </div>
                <div class="col-md mb-3 mb-md-0 mobiscroll-select" *ngIf="accountId">
                    <label class="form-label d-block">New Parent Entity</label>
                    <input id="move-parent-input" class="mobi-input form-control form-control-lg"
                        placeholder="Select Entity" mbsc-select [data]="parents" [(ngModel)]="parentId" name="parentId"
                        [mbscOptions]="parentOptions" />
                </div>
            </div>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="dismiss()"><i
                    class="far fa-times"></i> Cancel</button>
            <button type="submit" class="btn btn-secondary btn-round btn-lg" (click)="moveEntity()"><i
                    class="far fa-check"></i>
                Re-Assign</button>
        </div>
    </form>
</ng-container>